import { useMemo } from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';

const justModuleAndFeatureRegex = /^\/\w+\/\w+/g;

const useAsiteRelaticsRoutes = () => {
    const { path, url } = useRouteMatch();
    const { pathname } = useLocation();

    // Improvement - Redirect if no correct route is passed here
    const matchedPathname = pathname.match(justModuleAndFeatureRegex) || '';

    const routes = useMemo(
        () => ({
            relatics: `${path}/relatics`,
            asite: `${path}/asite`,
            configuration: `${path}/configuration`,
            realtime:  `${path}/realtime`,
        }),
        [path],
    );

    return { routes, path, url, matchedPathname };
};

export default useAsiteRelaticsRoutes;
